import React, { createContext, useState } from 'react';

export const AWSContext = createContext();

export const AWSProvider = ({ children }) => {
  const [isAWS, setIsAWS] = useState(false);
  const [isBig, setIsBig] = useState(false); // AGREGAR estado para rol Big

  return (
    <AWSContext.Provider value={{ isAWS, setIsAWS, isBig, setIsBig }}>
      {children}
    </AWSContext.Provider>
  );
};